import API from '@/views/Fdc/Apis/'
import SpcRuleModal from './SpcRuleModal.vue'
// import _ from 'lodash'

export default {
  name: 'SpcRuleManager',
  components: {
    'spc-rule-modal': SpcRuleModal
  },
  beforeMount () {
    this.initDefaultColumns()
    this.initColumns()
  },
  mounted () {
    this.getDefaultList()
    this.getCustomList()
    this.codeList()
  },
  updated () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /**
     * 공통 코드 List를 조회합니다.
     */
    async codeList () {
      const payload = {
        codeType: this.replaceComma(JSON.stringify(this.codeType))
      }
      await API.Common.getMultiTypeCodes(payload, this.codeCallback)
    },
    /**
     * 공통 코드 List 조회 후 실행되는 콜백 함수입니다.
     * @param {Array} response
     */
    codeCallback (response) {
      this.spcCodeList = response.data
      this.spcRuleModal.codeList = this.spcCodeList
    },
    /**
     * 문자열에서 특정 문자를 제거합니다.
     * @param {String} str 대상 문자열
     * @returns 변형한 문자열
     */
    replaceComma (str) {
      str = str.replace('[', '')
      str = str.replace(']', '')
      str = str.replace(/\"/g, '')
      return str
    },
    /**
     * 조회된 결과를 Excel 파일로 저장합니다.
     * @param {String} division 대상 Grid를 특정하는 별칭
     */
    exportExcel (division) {
      if (division === 'default') {
        this.$refs.spcDefaultRuleGrid.gridApi.exportDataAsCsv({
          fileName: 'SpcDefaultRule.csv'
        })
      } else if (division === 'custom') {
        this.$refs.spcRuleManagerGrid.gridApi.exportDataAsCsv({
          fileName: 'SpcCustomRule.csv'
        })
      }
    },

    /**
     * Default Rule Grid의 컬럼을 설정합니다.
     */
    initDefaultColumns () {
      this.defaultColumns = [
        { headerName: 'Rule No', field: 'ruleNo', width: 120, type: 'numericColumn', filter: false, required: true },
        { headerName: 'Rule Description', field: 'ruleDesc', width: 440, filter: false, required: true },
        { headerName: 'Detection Count {m}', field: 'detectionCount', width: 165, type: 'numericColumn', required: true },
        { headerName: 'Sample Count {n}', field: 'sampleCount', width: 145, type: 'numericColumn', required: true },
        { headerName: 'Compare Limit {k}', field: 'limitCodeName', width: 180, required: true },
        { headerName: 'Operation', field: 'operCodeName', width: 180, required: true }
      ]
    },
    /**
     * Default Rule을 조회합니다.
     */
    async getDefaultList () {
      let data = await API.Model.getSpcRules({ customYn: 'N' })
      this.defaultRowData = data
    },

    /**
     * User Custom Rule의 컬럼을 설정합니다.
     */
    initColumns () {
      this.columns = [
        { headerName: 'Rule No', field: 'ruleNo', width: 120, type: 'numericColumn', filter: false, required: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: 'Rule Description', field: 'ruleDesc', width: 440, filter: false, required: true },
        { headerName: 'Detection Count {m}', field: 'detectionCount', width: 165, type: 'numericColumn', required: true },
        { headerName: 'Sample Count {n}', field: 'sampleCount', width: 145, type: 'numericColumn', required: true },
        { headerName: 'Compare Limit {k}', field: 'limitCodeName', width: 180, required: true },
        { headerName: 'Operation', field: 'operCodeName', width: 180, required: true },
        { headerName: 'Modify Time', field: 'modifyDt', width: 180, type: 'dateTimeColumn', filter: false, required: true },
        { headerName: 'Modify User', field: 'modifyUser', width: 130, required: true }
      ]
    },
    /**
     * User Custom Rule을 조회합니다.
     */
    async getCustomList () {
      let data = []
      data = await API.Model.getSpcRules({ customYn: 'Y' })

      data.forEach(row => {
        if (row.compareLimit === 'DIRECT_INPUT') {
          row.limitCodeName = row.limitCodeName.replace('{', '').replace('}', '')
        }
      })

      this.rowData = data
    },
    /**
     * 체크된 Row Count가 1인지 확인합니다.
     * @returns {Boolean} 1개 체크 여부
     */
    hasOneCheckedRow () {
      if (!this.$refs.spcRuleManagerGrid) {
        return 0
      }
      return this.$refs.spcRuleManagerGrid.checkedRowCount === 1
    },
    /**
     * 체크된 Row Count가 1 이상인지 확인합니다.
     * @returns {Boolean} 체크 여부
     */
    hasCheckedRow () {
      if (!this.$refs.spcRuleManagerGrid) {
        return 0
      }
      return this.$refs.spcRuleManagerGrid.checkedRowCount > 0
    },
    /**
     * 체크된 User Custom Rule들을 삭제합니다.
     */
    async ruleDelete () {
      let deleteRows = this.$refs.spcRuleManagerGrid.getCheckedRows()
      if (deleteRows.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED'))
        return
      }

      let self = this // vue instance

      this.$dialog.confirm({
        message: (deleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              self.getCustomList()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (deleteRows.length > 0) {
            API.Model.deleteSpcRules(deleteRows).then(response => {
              deleteLastProcess(response)
            })
          }
        },
        oncancel: function () {}
      })
    },
    // /**
    //  * 조회된 Grid의 전체 row 중 체크된 row를 반환합니다.
    //  * @param {Array} allRows Grid의 전체 row
    //  * @returns 체크된 row
    //  */
    // getCheckedRows (allRows) {
    //   let checkedRows = []
    //   if (allRows.length > 0) {
    //     for (var i = 0; i < allRows.length; i++) {
    //       if (allRows[i].dataItem._status.checked) {
    //         var data = _.clone(allRows[i].dataItem)
    //         delete data['_status'] // grid에서 넘겨주는 속성. 이거 지워야 서버로 JSON 넘길 때 에러 안 남
    //         checkedRows.push(data)
    //       }
    //     }
    //   }
    //   return checkedRows
    // },

    /**
     * 새 User Custom Rule을 생성하는 Modal을 화면에 표시합니다.
     */
    newRuleAdd () {
      this.spcRuleModal.type = 'Add'
      this.spcRuleModal.visible = true
      this.initValue = { 'usedRuleNoList': this.getRuleNoList() }
    },
    /**
     * 기존 User Custom Rule을 수정하는 Modal을 화면에 표시합니다.
     */
    ruleEdit () {
      this.spcRuleModal.type = 'Edit'
      this.spcRuleModal.visible = true
      this.initEditModal()
    },
    /**
     * 조회된 Rule들을 기준으로, 기존에 사용중인 Rule No List를 생성합니다.
     * @returns {Array} Rule No List
     */
    getRuleNoList () {
      let ruleNoList = []
      this.defaultRowData.forEach(row => {
        ruleNoList.push(row.ruleNo)
      })
      this.rowData.forEach(row => {
        ruleNoList.push(row.ruleNo)
      })
      return ruleNoList
    },
    /**
     * Edit Modal에 필요한 init Value를 Setting합니다.
     */
    initEditModal () {
      const checkedRow = this.$refs.spcRuleManagerGrid.getCheckedRows()
      console.log(checkedRow)
      this.initValue = checkedRow[0]
    },
    /**
     * Modal을 닫습니다.
     */
    closeModal () {
      this.spcRuleModal.visible = false
      this.initValue = {}
    }
  },
  data () {
    return {
      spcCodeList: [],
      codeType: [
        'COMPARE_OPERATION', 'COMPARE_LIMIT'
      ],

      // Default Rule
      defaultColumns: [],
      defaultRowData: [],

      // User Custom Rule
      columns: [],
      rowData: [],

      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting

      // Save Modal
      spcRuleModal: {
        visible: false
        // compareOperList: []
      },
      initValue: {}
    }
  }
}
